<template>
	<el-row>
		<el-aside width="100%" style=";min-width:180px;max-width:185px;background-color:#2A303E;height:100%;text-align: center;">
			<el-menu
					:default-active="activeMenu"
					background-color="#2A303E"
					text-color="#fff"
					active-text-color="#1b96a9"
					class="menu"
					@select="handleSelect"
					:unique-opened="true"
					:router="true"
					style=""
					ref="myMenu">
				<!-- <template v-for="(item,index) in menuInfo">
					<el-menu-item style="padding: 0;" :index="''+item.url"  v-if="item.child_menus && item.child_menus.length===0">
					  <span slot="title">{{item.menuName}}</span>
					</el-menu-item>
					<el-submenu :index="''+item.url" v-else="item.child_menus && item.child_menus.length>0" >
					  <span slot="title">{{item.menuName}}</span>
					  <el-menu-item unique-opened :index="''+items.url" v-for="(items,index) in item.child_menus" :key="items.url" style="width:100px">{{items.menuName}}</el-menu-item>
					</el-submenu>
				  </template> -->
				<router-link to="/home">
					<el-menu-item index="home">
						<i class="el-icon-menu"></i>
						<span slot="title" style="margin-right: 17px">首页</span>
					</el-menu-item>
				</router-link>
				<router-link to="/OrderDetails" v-if="ScenicSpot">
					<el-menu-item index="OrderDetails">
						<i class="el-icon-menu"></i>
						<span slot="title" style="margin-right: 17px">订单详情</span>
					</el-menu-item>
				</router-link>
				<!-- <router-link to="/PackageOrders"v-if="ScenicSpot">
				  <el-menu-item index="PackageOrders">
					<i class="el-icon-menu"></i>
					<span slot="title" style="margin-right: 17px">套餐订单</span>
				  </el-menu-item>
				</router-link> -->
				<router-link to="/storeManagement" v-if="pages">
					<el-menu-item index="storeManagement">
						<i class="el-icon-menu"></i>
						<span slot="title" style="margin-right: 17px">景区景点管理</span>
					</el-menu-item>
				</router-link>
				<router-link to="/homePageImg" v-if="pages">
					<el-menu-item index="homePageImg">
						<i class="el-icon-menu"></i>
						<span slot="title" style="margin-right: 17px">小程序图片设置</span>
					</el-menu-item>
				</router-link>

				<router-link to="/order" v-if="pages">
					<el-menu-item index="order">
						<i class="el-icon-menu"></i>
						<span slot="title" style="margin-right: 17px">订单管理</span>
					</el-menu-item>
				</router-link>

				<router-link to="/SetMeal" v-if="pages">
					<el-menu-item index="SetMeal">
						<i class="el-icon-menu"></i>
						<span slot="title" style="margin-right: 17px">套餐管理</span>
					</el-menu-item>
				</router-link>
				<router-link to="/couponPackage" v-if="pages">
					<el-menu-item index="couponPackage">
						<i class="el-icon-menu"></i>
						<span slot="title" style="margin-right: 17px">券包管理</span>
					</el-menu-item>
				</router-link>
				<router-link to="/cardList" v-if="pages">
					<el-menu-item index="cardList">
						<i class="el-icon-menu"></i>
						<span slot="title" style="margin-right: 17px">明信片管理</span>
					</el-menu-item>
				</router-link>
				<router-link to="/cardOrder">
					<el-menu-item index="cardOrder">
						<i class="el-icon-menu"></i>
						<span slot="title" style="margin-right: 17px">明信片订单</span>
					</el-menu-item>
				</router-link>
				<router-link to="/sms" v-if="pages">
					<el-menu-item index="sms">
						<i class="el-icon-menu"></i>
						<span slot="title" style="margin-right: 17px">短信管理</span>
					</el-menu-item>
				</router-link>
				<router-link to="/shopManage" v-if="pages">
					<el-menu-item index="shopManage">
						<i class="el-icon-menu"></i>
						<span slot="title" style="margin-right: 17px">店铺管理</span>
					</el-menu-item>
				</router-link>
				<router-link to="/statistics" v-if="!pages">
					<el-menu-item index="statistics">
						<i class="el-icon-menu"></i>
						<span slot="title" style="margin-right: 17px">券统计</span>
					</el-menu-item>
				</router-link>
				<router-link to="/activityList" v-if="pages">
					<el-menu-item index="activityList">
						<i class="el-icon-menu"></i>
						<span slot="title" style="margin-right: 17px">活动管理</span>
					</el-menu-item>
				</router-link>
				<router-link to="/MemberList" v-if="pages">
					<el-menu-item index="MemberList">
						<i class="el-icon-menu"></i>
						<span slot="title" style="margin-right: 17px">用户管理</span>
					</el-menu-item>
				</router-link>
				<router-link to="/AccountList" v-if="pages">
					<el-menu-item index="AccountList">
						<i class="el-icon-menu"></i>
						<span slot="title" style="margin-right: 17px">账号管理</span>
					</el-menu-item>
				</router-link>
				<router-link to="/password">
					<el-menu-item index="password">
						<i class="el-icon-menu"></i>
						<span slot="title" style="margin-right: 17px">密码管理</span>
					</el-menu-item>
				</router-link>
			</el-menu>
		</el-aside>
	</el-row>
</template>
<script>
import ElRow from "element-ui/packages/row/src/row";
import ElCol from "element-ui/packages/col/src/col";
import {mapState} from "vuex";
import axios from "axios";
import qs from "qs";
import ElAside from "element-ui/packages/aside/src/main";

export default {
	data() {
		return {
			activeMenu: "",
			menuInfo: [],
			stateInfo: 1,
			pages: false,
			ScenicSpot: true
		};
	},
	components: {},
	mounted() {
		var userData = qs.parse(sessionStorage.getItem("userData"));
		// console.log(userData)
		this.stateInfo = userData.father_serial;
		this.initMenu();
		if (userData.role_lx == 1) {
			this.pages = true
			this.ScenicSpot = false
		} else if (userData.role_lx == 2) {
			this.pages = false
			this.ScenicSpot = true
		}
		//加载菜单
		// var that = this;
		// var companyData = {};
		// var mustParams = {
		//   methodUrl: "adminMenu/getMenuList",
		//   jsonParam: qs.stringify(companyData)
		// };
		// this.$axios.postRequest(mustParams).then(
		//   function(res) {
		//     //成功之后处理逻辑
		//     that.menuInfo = res.data;
		//   },
		//   function(res) {
		//     //失败之后处理逻辑
		//     console.log("error:");
		//   }
		// );
	},
	methods: {
		initMenu() {
			var last = this.$route.path.lastIndexOf("/");
			if (last != 0) {
				this.activeMenu = this.$route.path.substring(1, last);
			} else {
				this.activeMenu = this.$route.path.replace("/", "");
			}
		},
		initMenu() {
			this.activeMenu = this.$route.path.replace("/", "");
		},
		handleSelect(index, indexPath) {
			var menu = this.$refs.myMenu;
			for (var i = 0; i < menu.$children.length; i++) {
				if (menu.$children[i].$children.length != 0 && menu.$children[i].opened) {
					for (var x = 0; x < menu.$children[i].$children.length; x++) {
						if (menu.$children[i].$children[x].index != index) {
							menu.close(menu.$children[i].index);
						}
					}
				}
			}
		}
	},

	computed: {
		//获取菜单
	},

	watch: {
		// 如果路由有变化，会再次执行该方法
		$route: "initMenu"
	}
};
</script>
<style scoped>
div,
p,
ul,
li,
o,
tbody,
tfoot,
thead,
fieldset,
legend {
	margin: 0;
	padding: 0;
}

.menu {
	width: 100%;
	text-align: left;
	font-size: 14px;
	font-weight: 600;
	/* height: 100%; */
}

.personal {
	width: 15%;
	background-color: red;
}

.group > ul > li {
}

.user {
	background-color: #1b96a9;
}

/* .user img {
  width: 61px;
  height: 100%;
  margin: 0;
  padding: 10px 0 10px 0;
  vertical-align: middle;
  text-align: center;
} */
.sizer {
	color: #101010;
}

/*.el-menu-item{*/
/*font-size:18px;*/
/*}*/
/*.el-submenu{*/
/*font-size:18px;*/
/*}*/
</style>



// WEBPACK FOOTER //
// src/components/headerMenuLogin/pageMenu.vue